var React = require('react');

function Cf (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-12.4 32h640v480h-640z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"translate(12.4 -32)","key":1},[React.createElement("path",{"fill":"#00f","d":"M-52 32h719.3v119H-52z","key":0}),React.createElement("path",{"fill":"#ff0","d":"M-52 391.6h719.3V512H-52z","key":1}),React.createElement("path",{"fill":"#009a00","d":"M-52 271.3h719.3v120.3H-52z","key":2}),React.createElement("path",{"fill":"#fff","d":"M-52 151h719.3v120.3H-52z","key":3}),React.createElement("path",{"fill":"red","d":"M247.7 32.5h119.9V512H247.7z","key":4}),React.createElement("path",{"fill":"#ff0","d":"M99.3 137.7l-31.5-21.8-31.3 22L47.4 101 16.9 78l38.2-1 12.5-36.3L80.3 77l38.1.7L88.2 101","key":5})])]);
}

Cf.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Cf;

Cf.default = Cf;
